/* UpCart drawer: links the Red Line stylesheet (assets/pa-rl-upcart.css) into UpCart's shadow root and
   makes the few markup tweaks CSS can't: the item count in the header, insurance tiles marked so they
   can be styled as a service row, add-on descriptions hidden, the discount summary row marked, and
   Shopify's default "Title: " option label removed. Loaded from layout/theme.liquid. */
(function () {
  var LINK_ID = 'pa-rl-upcart-css';
  var HOST_ATTR = 'data-pa-upcart-compact';
  var ENHANCED_ATTR = 'data-pa-enhanced';
  var script = document.currentScript;
  var cssUrl = script && script.getAttribute('data-pa-upcart-css');
  var hostsObserved = new WeakSet();

  function forEach(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function setAttr(node, name, value) {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  }

  function ensureStylesheet(shadowRoot) {
    if (!cssUrl || shadowRoot.getElementById(LINK_ID)) return;
    var link = document.createElement('link');
    link.id = LINK_ID;
    link.rel = 'stylesheet';
    link.href = cssUrl;
    shadowRoot.appendChild(link);
  }

  function findAddOnRoots(shadowRoot) {
    return shadowRoot.querySelectorAll(
      '.upcart-public-addons, .upcart-internal-addons, [class*="public-addons"], [class*="internal-addons"]'
    );
  }

  function hideAddOnDescriptions(root) {
    forEach(
      root.querySelectorAll(
        '[data-upcart-chunk="addon-description"], .upcart-public-addons__content-description, .upcart-internal-addons__content-description, [class*="addons__content-description"]'
      ),
      function (descriptionNode) {
        if (descriptionNode.hidden) return;
        descriptionNode.setAttribute('data-pa-addon-description', 'hidden');
        descriptionNode.hidden = true;
        descriptionNode.style.setProperty('display', 'none', 'important');
      }
    );
  }

  function enhanceAddOnRoot(root) {
    var marks = [
      ['.upcart-public-addons__content-wrapper, .upcart-internal-addons__content-wrapper, [class*="addons__content-wrapper"]', ENHANCED_ATTR],
      ['.upcart-public-addons__content-title-wrapper, .upcart-internal-addons__content-title-wrapper, [class*="addons__content-title-wrapper"]', ENHANCED_ATTR],
      ['.upcart-public-addons__content-title, .upcart-internal-addons__content-title, [class*="addons__content-title"]', 'data-pa-addon-title'],
      ['.upcart-public-addons__content-price, .upcart-internal-addons__content-price, [class*="addons__content-price"]', 'data-pa-addon-price'],
      ['.upcart-public-addons__toggle-wrapper, .upcart-internal-addons__toggle-wrapper, [class*="addons__toggle-wrapper"]', 'data-pa-addon-toggle']
    ];
    marks.forEach(function (mark) {
      var node = root.querySelector(mark[0]);
      if (node) setAttr(node, mark[1], 'true');
    });
    hideAddOnDescriptions(root);
    setAttr(root, ENHANCED_ATTR, 'true');
  }

  function hideByClassFragment(root, fragment) {
    forEach(root.querySelectorAll('[class*="' + fragment + '"]'), function (node) {
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function isInsuranceTile(tile) {
    var titleNode = tile.querySelector('[class*="product-tile__product-title"], [class*="product-tile__title-link"]');
    return /insurance/i.test(normalizeText(titleNode ? titleNode.textContent : tile.textContent));
  }

  function normalizeInsuranceTiles(shadowRoot) {
    forEach(
      shadowRoot.querySelectorAll(
        '.upcart-public-component-product-tile, .upcart-internal-component-product-tile, [class*="component-product-tile"]:not([class*="component-product-tile__"])'
      ),
      function (tile) {
        if (!isInsuranceTile(tile)) {
          tile.removeAttribute('data-pa-insurance-tile');
          return;
        }
        setAttr(tile, 'data-pa-insurance-tile', 'true');
        hideByClassFragment(tile, 'subscription-upgrade');
        hideByClassFragment(tile, 'quantity-selector');
      }
    );
  }

  // Shopify names a product's only option "Title"; the drawer prints it as "Title: 50 Rounds (Just 1 Box)"
  function stripDefaultOptionLabel(shadowRoot) {
    forEach(shadowRoot.querySelectorAll('[class*="product-tile__variant"] span'), function (span) {
      if (span.children.length || !/^Title:\s/.test(span.textContent)) return;
      span.textContent = span.textContent.replace(/^Title:\s+/, '');
    });
  }

  // "2 items" next to "Your cart"; insurance isn't counted, and an empty cart shows no count
  function updateHeaderCount(shadowRoot) {
    var header = shadowRoot.querySelector('.upcart-public-header, .upcart-internal-header');
    if (!header) return;
    var count = 0;
    forEach(shadowRoot.querySelectorAll('.upcart-public-cart-item, .upcart-internal-cart-item'), function (line) {
      if (line.querySelector('[data-pa-insurance-tile]')) return;
      var input = line.querySelector('[class*="quantity-selector"] input');
      var qty = input ? parseInt(input.value, 10) : 1;
      count += isNaN(qty) ? 1 : qty;
    });
    if (!count) {
      header.removeAttribute('data-pa-count');
      return;
    }
    setAttr(header, 'data-pa-count', count + (count === 1 ? ' item' : ' items'));
  }

  function normalizeFooterDiscountRows(shadowRoot) {
    forEach(
      shadowRoot.querySelectorAll('.upcart-public-cart-summary, .upcart-internal-cart-summary'),
      function (summary) {
        var discountCodes = summary.querySelector(
          '.upcart-public-cart-summary__discount-codes, .upcart-internal-cart-summary__discount-codes'
        );
        var totalDiscount = summary.querySelector(
          '.upcart-public-cart-summary__total-discount, .upcart-internal-cart-summary__total-discount'
        );
        if (!discountCodes || !totalDiscount) {
          summary.removeAttribute('data-pa-discount-row');
          return;
        }
        setAttr(summary, 'data-pa-discount-row', 'true');
        if (totalDiscount.parentElement) setAttr(totalDiscount.parentElement, 'data-pa-discount-total-wrap', 'true');
      }
    );
  }

  function processShadow(shadowRoot) {
    ensureStylesheet(shadowRoot);
    forEach(findAddOnRoots(shadowRoot), enhanceAddOnRoot);
    normalizeInsuranceTiles(shadowRoot);
    stripDefaultOptionLabel(shadowRoot);
    updateHeaderCount(shadowRoot);
    normalizeFooterDiscountRows(shadowRoot);
  }

  function scheduleShadowProcess(shadowRoot) {
    if (shadowRoot.__paCompactQueued) return;
    shadowRoot.__paCompactQueued = true;

    requestAnimationFrame(function () {
      shadowRoot.__paCompactQueued = false;
      processShadow(shadowRoot);
    });
  }

  function observeHost(host) {
    if (!host || !host.shadowRoot || hostsObserved.has(host)) return;

    hostsObserved.add(host);
    host.setAttribute(HOST_ATTR, 'true');

    var shadowRoot = host.shadowRoot;
    scheduleShadowProcess(shadowRoot);

    var observer = new MutationObserver(function () {
      scheduleShadowProcess(shadowRoot);
    });
    observer.observe(shadowRoot, { childList: true, subtree: true, characterData: true });
    // Typing a quantity changes the input's value, not the DOM
    shadowRoot.addEventListener('input', function () { scheduleShadowProcess(shadowRoot); }, true);
  }

  function findHost() {
    return document.getElementById('upCart') || document.querySelector('[id*="upcart" i]');
  }

  function boot() {
    var host = findHost();
    if (host && host.shadowRoot) observeHost(host);

    var bodyObserver = new MutationObserver(function () {
      var nextHost = findHost();
      if (nextHost && nextHost.shadowRoot) observeHost(nextHost);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
